'use client';

import { Container } from '@/shared/ui';
import { Button } from '@/shared/ui/button';
import AuthWidget from '@/widgets/auth-widget';
import { Text } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import { useState } from 'react';

const AlertAuth = () => {
  const t = useTranslations('profile');
  const [isAuthDialog, setIsAuthDialog] = useState(false);
  return (
    <Container py="4" gap="4" justifyContent="space-between">
      <Text fontSize="sm">{t('alert_auth')}</Text>
      <Button
        bg="primary"
        color="primary.text"
        onClick={() => setIsAuthDialog(true)}
      >
        {t('login')}
      </Button>

      <AuthWidget open={isAuthDialog} onClose={() => setIsAuthDialog(false)} />
    </Container>
  );
};

export default AlertAuth;
